"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _formWrapper = _interopRequireDefault(require("../formWrapper.js"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy3"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle2"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdFormik = require("cccisd-formik");
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _generateNewId = require("../../helpers/generateNewId");
var _HelpText = _interopRequireDefault(require("../components/HelpText"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _style = _interopRequireDefault(require("./style.css"));
var _reportTemplates = _interopRequireDefault(require("./reportTemplates.js"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var appDefs = window.cccisd.appDefs;
var reportTemplateOptions = [{
  value: '',
  label: '-- Choose report template --'
}].concat(_toConsumableArray(_reportTemplates["default"].map(function (item) {
  return {
    value: item.handle,
    label: item.label
  };
})));
var ReportsForm = function ReportsForm(props) {
  var Link = props.Link,
    settings = props.settings,
    updateSettings = props.updateSettings;
  var addReport = function addReport(values, closeModal) {
    var concatName = values.id.replace(/\s+/g, '');
    var selectedReportTemplate = _reportTemplates["default"].find(function (item) {
      return item.handle === values.reportTemplateHandle;
    });
    updateSettings({
      list: [].concat(_toConsumableArray(settings.list || []), [{
        id: (0, _generateNewId.generateNewId)({
          prefix: concatName,
          settings: settings.list
        }),
        roles: values.userRole,
        reportTemplateHandle: values.reportTemplateHandle,
        reportTemplateSettings: selectedReportTemplate.builderInitialValues
      }])
    });
    closeModal();
  };
  var duplicateReport = function duplicateReport(id) {
    var duplicatedCenter = (0, _cloneDeep2["default"])(settings.list.find(function (rv) {
      return rv.id === id;
    }));
    updateSettings({
      list: [].concat(_toConsumableArray(settings.list), [_objectSpread(_objectSpread({}, duplicatedCenter), {}, {
        id: (0, _generateNewId.generateNewId)({
          prefix: duplicatedCenter.id,
          settings: settings.list
        })
      })])
    });
  };
  var deleteReport = function deleteReport(id) {
    var newList = settings.list.filter(function (rv) {
      return rv.id !== id;
    });
    updateSettings({
      list: newList
    });
  };
  var addReportValidate = function addReportValidate(values) {
    var errors = {};
    if (!values.id) {
      errors.id = 'Handle is required';
    }
    if (!values.userRole) {
      errors.userRole = 'User role is required';
    }
    return errors;
  };
  var _getUserRolesOptions = function _getUserRolesOptions() {
    var userRolesOptions = [{
      value: 'individual',
      label: 'Individual'
    }, {
      value: 'group',
      label: 'Group'
    }, {
      value: 'provider',
      label: 'Provider'
    }, {
      value: 'site',
      label: 'Site'
    }, {
      value: 'uber',
      label: 'Uber'
    }];
    if (appDefs.pawn.roles && appDefs.pawn.roles.length > 0) {
      userRolesOptions = appDefs.pawn.roles.map(function (role) {
        return {
          value: role.handle,
          label: role.label
        };
      });
    }
    return userRolesOptions;
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", null, "Reports GUI"), /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
    text: "Welcome. Please click on a Report to edit it, or click Add New to add a new Report."
  }), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary",
      style: {
        marginBottom: '0.5em'
      }
    }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null), " Add New"),
    title: "Add New Report",
    render: function render(_ref) {
      var closeModal = _ref.closeModal;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        onSubmit: function onSubmit(values) {
          return addReport(values, closeModal);
        },
        validate: addReportValidate,
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].horizontal
          }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "id",
            component: _cccisdFormik.CccisdInput,
            label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Handle", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
              title: "Handle should not contain spaces."
            }, /*#__PURE__*/_react["default"].createElement(_question["default"], null))),
            autoFocus: true
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "userRole"
          }, function (_ref2) {
            var field = _ref2.field,
              form = _ref2.form;
            var handleOnChange = function handleOnChange(e) {
              var value = e.target.value;
              form.setFieldValue('userRole', (0, _xor2["default"])(field.value, [value]));
            };
            return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
              field: field,
              form: form,
              label: "User Role(s)"
            }, _getUserRolesOptions().map(function (role) {
              return /*#__PURE__*/_react["default"].createElement("div", {
                key: role.value
              }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
                type: "checkbox",
                value: role.value,
                onChange: handleOnChange
              }), ' ', role.label));
            }));
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "reportTemplateHandle",
            component: _cccisdFormik.CccisdSelect,
            label: "Report Template",
            options: reportTemplateOptions
          }), /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-primary",
            type: "submit"
          }, "Add Report")));
        }
      });
    }
  }), settings.list && settings.list.length > 0 && /*#__PURE__*/_react["default"].createElement("table", {
    className: _style["default"].rcTable
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
    width: "20%"
  }, "Actions"), /*#__PURE__*/_react["default"].createElement("th", {
    width: "40%"
  }, "Handle"), /*#__PURE__*/_react["default"].createElement("th", {
    width: "40%"
  }, "User Roles"))), /*#__PURE__*/_react["default"].createElement("tbody", null, settings.list.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: item.id
    }, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Duplicate"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default btn-xs",
      onClick: function onClick() {
        return duplicateReport(item.id);
      },
      style: {
        marginRight: '0.5em'
      }
    }, /*#__PURE__*/_react["default"].createElement(_copy["default"], null))), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Delete"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_cross["default"], null),
      className: "btn btn-danger btn-xs",
      isConfirm: true,
      confirmationMessage: "Are you sure you want to delete this Report: ".concat(item.title || "Unlabeled Report ".concat(index + 1), "?"),
      onClick: deleteReport.bind(null, item.id)
    }))), /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(Link, {
      path: "list[".concat(index, "]")
    }, item.id || "Unlabeled Report ".concat(index + 1)), ' '), /*#__PURE__*/_react["default"].createElement("td", null, item.roles.join(', ')));
  }))));
};
var _default = exports["default"] = (0, _formWrapper["default"])()(ReportsForm);